import { render, staticRenderFns } from "./SessionLiveMetadataView.vue?vue&type=template&id=353d4fba&scoped=true"
import script from "./SessionLiveMetadataView.js?vue&type=script&lang=js&external"
export * from "./SessionLiveMetadataView.js?vue&type=script&lang=js&external"
import style0 from "./SessionLiveMetadataView.vue?vue&type=style&index=0&id=353d4fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d4fba",
  null
  
)

export default component.exports